
import * as angular from "angular";

export interface IKeyWordTriggerDirectiveScope extends angular.IScope {
    keyWordTrigger: () => void;
}

export class KeyWordTriggerDirective implements angular.IDirective {

    restrict = "A";
    scope = {
        keyWordTrigger: "&"
    }

    link: ($scope: IKeyWordTriggerDirectiveScope, element: angular.IAugmentedJQuery, attrs: angular.IAttributes) => void;

    constructor($timeout: angular.ITimeoutService, $document: angular.IDocumentService) {

        KeyWordTriggerDirective.prototype.link = ($scope: IKeyWordTriggerDirectiveScope, $element: angular.IAugmentedJQuery, $attrs: ng.IAttributes) => {

            const triggerWord = $attrs["wordTrigger"];
            if (!triggerWord) {
                console.error("KeyWordTrigger requires a trigger word", $attrs, $element[0]);
                return;
            }

            const triggerWordArray: string[] = [];
            const keyBuffer: string[] = [];

            for (let i = 0; i < triggerWord.length; i++) {
                triggerWordArray.push(triggerWord[i]);
            }

            $element.on("keydown", (eventObject: JQueryEventObject) => {
                keyBuffer.push(String.fromCharCode(eventObject.keyCode).toLowerCase());
                while (keyBuffer.length > triggerWordArray.length) {
                    keyBuffer.shift();
                }

                if (triggerWordArray.join("") === keyBuffer.join("")) {
                    if ($scope.keyWordTrigger) {
                        $scope.keyWordTrigger();
                        $scope.$applyAsync();
                    }
                }
            });

            $scope.$on("$destroy", () => {
                $element.off("keydown");
            });
        }
    }

    static factory(): angular.IDirectiveFactory {
        const directive = ($timeout: angular.ITimeoutService, $document: angular.IDocumentService) => new KeyWordTriggerDirective($timeout, $document);

        directive.$inject = ["$timeout", "$document"];

        return directive;
    }
}
